import React, { useState } from "react";
import * as R from "ramda";
import { Modal } from "antd";

import Table from "@arachnys/styleguide/Table";
import { DocumentLink } from "@arachnys/flow-app/src/container/Documents";
import { formatDatetimeString } from "@arachnys/flow-app/src/formatters/formatDateTimeString";
import { DEFAULT_PAGESIZE_S } from "@arachnys/flow-app/src/config";
import { fileTypes } from "./config";

const columns = [
    {
        Header: "Upload Date",
        id: "uploaddate",
        Cell: row => formatDatetimeString({ str: row.original.createdAt }),
    },
    {
        Header: "File name",
        id: "filename",
        Cell: row => {
            const file = row.original;
            return (
                file && (
                    <DocumentLink
                        documentDatum={{
                            documentId: file.docstoreId,
                            documentName: file.fileName,
                        }}
                    />
                )
            );
        },
    },
];

const AdditionalFilesPopup = ({ request }) => {
    const [isOpen, setOpen] = useState(false);
    const setPopupState = state => () => setOpen(state);

    return (
        <>
            <a onClick={setPopupState(true)}>View Results</a>
            <Modal
                visible={isOpen}
                onCancel={setPopupState(false)}
                title={`Results for ${request.name}`}
                footer={null}
            >
                <Table
                    defaultPageSize={DEFAULT_PAGESIZE_S}
                    columns={columns}
                    data={R.filter(
                        R.propEq("fileType", fileTypes.REPORT),
                        request.fileUploads
                    )}
                />
            </Modal>
        </>
    );
};

export default AdditionalFilesPopup;
